import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { AsamcoAuthGuard } from '@asamco/base';
import { RemoteIframeComponent } from './remote-iframe/remote-iframe.component';

const canActivateChild: CanActivateChildFn = (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	return inject(AsamcoAuthGuard).canActivateChild(childRoute, state);
};

export const routes = [
    {
        path: '**',
        component: RemoteIframeComponent,
        canActivateChild: [canActivateChild]
    },
];
